<template>
  <v-snackbar v-model="snackbarOpen" :color="color" :timeout="timeout" :top="top" bottom right>
    {{ messageProp }}
  </v-snackbar>
</template>

<script>
export default {
  name: 'simple-snackbar',
  props: {
    open: Boolean,
    messageProp: String,
    color: {
      type: String,
      default: 'primary',
    },
    timeout: {
      type: Number,
      default: 4000,
    },
    top: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { snackbarOpen: false }
  },
  watch: {
    open: {
      handler(value) {
        this.snackbarOpen = value
      },
      immediate: true,
    },
    snackbarOpen(current, prev) {
      if (prev !== current) this.$emit('update:open', current)
    },
  },
}
</script>

<style scoped></style>
